import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute} from '@angular/router';
import { PagosService } from '../../services/pagos.service';
import { ConveniosService } from '../../services/convenios.service';
import { HelpersService } from '../../services/tools/helpers.service';
import { ModalConfirmacionPagosComponent } from './components/modal-confirmacion-pagos/modal-confirmacion-pagos.component';

@Component({
    selector: 'app-convenios-pagos-multiples',
    templateUrl: './convenios-pagos-multiples.component.html'
  })

export class ConveniosPagosMultiplesComponent implements OnInit {
  @ViewChild(ModalConfirmacionPagosComponent) modalConfirmacionPagos: ModalConfirmacionPagosComponent;

    public isLoading: boolean = false;
    public pagos: any[] = [];
    public idConvenios: number = null;
    public convenio: any = {};
    public fechaFin: any = null;
    public mensajeError: string = null;

    constructor(
        private helperService: HelpersService,
        private pagosService: PagosService,
        private activeRoute: ActivatedRoute,
        private conveniosService: ConveniosService
    ){
    }

    public ngOnInit() {
      
      this.activeRoute.params.subscribe(params => {
        if(params['idConvenios']){
          let idConvenios = params['idConvenios'] ? +params['idConvenios'] : 0; // (+) converts string 'id' to a number
          this.idConvenios = idConvenios;
          
          //La fecha default es un mes a partir del día de hoy
          let fechaFin = new Date();
          fechaFin.setMonth(fechaFin.getMonth() + 1);
          this.fechaFin = this.helperService.dateToObj(fechaFin);

          //Cargar datos
          this.getPagosPendientes();
          this.getDetalleConvenio(idConvenios);
        } 
      });
    }

    public getPagosPendientes(){
    
        let filters = this.getFilters();

        this.isLoading = true;
        this.pagosService.getPagosPendientesDelConvenio(filters).subscribe(
          (response)=>
          {
            const jsonResult = response.json();
            this.pagos = jsonResult.content;
            
            this.isLoading = false;
          }, error =>
          {
            this.isLoading = false;
            // se resuelve error 403 y 500
            this.helperService.httpGlobalError(error);
            console.log('#Error', error);
            if(error.status == 400) {
              this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
            }
          }
        );
    }

    private getDetalleConvenio(idConvenios: number){

        this.isLoading = true;
        this.conveniosService.get(idConvenios).subscribe(
          (response)=>
          {
            const jsonResult = response.json();
            this.convenio = jsonResult.content;
            
            this.isLoading = false;
          }, error =>
          {
            this.isLoading = false;
            // se resuelve error 403 y 500
            this.helperService.httpGlobalError(error);
            console.log('#Error', error);
            if(error.status == 400) {
              this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
            }
          }
        );
    }

    public getFilters(){
      let filters = {
        idConvenios: this.idConvenios,
        fecha_fin: this.fechaFin ? this.helperService.dateToString(this.fechaFin) :null
      };

      return filters;
    }

    public makePayments(){
        
        let paymentsToDo = this.getPaymentsToDo();
        if(paymentsToDo.length > 0){
          this.mensajeError = null;
          this.modalConfirmacionPagos.openModal(paymentsToDo, this.convenio);
        }else{
          this.mensajeError = 'Selecciona algún registro para poder realizar el pago';
        }
    }

    private getPaymentsToDo(){
      let paymentsArray = []

      this.pagos.forEach(pago => {
        if(pago.realizarPago){
          paymentsArray.push({
            idCreditos: pago.idCreditos,
            monto_pago: +pago.monto_pago
          })
        }
      });

      return paymentsArray;
    }

    public changeFechaFin(event){
      this.fechaFin = event;
      this.getPagosPendientes();
    }
}


// WEBPACK FOOTER //
// ./src/app/convenios/pagos-multiples/convenios-pagos-multiples.component.ts